import { useQuery } from "@tanstack/react-query";
import { Competition, CompetitionsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchCompetition(id: string): Promise<Competition> {
    return new CompetitionsApi(getConfig()).getCompetitionsId({ id });
}

export function useGetCompetition(competitionId: string | undefined) {
    return useQuery({
        queryKey: ["competition", competitionId],
        queryFn: () => fetchCompetition(competitionId!),
        enabled: Boolean(competitionId),
        staleTime: 5 * 60 * 1000,
    });
}
